import { useEffect, useState } from 'react'
import { Target } from 'lucide-react'
import api from '@/services/api'
import { useAuthStore } from '@/store/authStore'
import { Card, CardContent } from '@/components/ui/card'

const usd = (cents) => `$${((cents || 0) / 100).toFixed(2)}`

/**
 * Meta del mes del asesor EMPLEADO (docs/cd2b-modelo-comercial-asesores.md D6): software nuevo
 * vendido frente a la meta que le fijó un administrador. Por debajo del mínimo de la política de su
 * país, ese mes no comisiona. El independiente no tiene meta: no se muestra nada.
 */
export default function MiMeta() {
  const empleado = useAuthStore((s) => s.partner?.vinculo) === 'empleado'
  const [avance, setAvance] = useState(null)

  useEffect(() => {
    if (!empleado) return
    api.get('/partners/cd2b/mi-meta')
      .then((r) => setAvance(r.data?.data || null))
      .catch(() => setAvance(null))
  }, [empleado])

  if (!empleado || !avance) return null
  if (!avance.metaCents) {
    return (
      <Card className="mb-4">
        <CardContent className="p-4 text-body-sm text-neutral-600 dark:text-neutral-400 flex items-center gap-2">
          <Target size={16} /> Tu supervisor aún no fija tu meta de {avance.periodo}.
        </CardContent>
      </Card>
    )
  }
  const pct = Math.min(100, avance.pct || 0)
  const umbral = avance.umbralPct
  return (
    <Card className="mb-4">
      <CardContent className="p-4 space-y-2">
        <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-0.5 text-body-sm">
          <span className="flex items-center gap-2 font-medium"><Target size={16} /> Meta de {avance.periodo}</span>
          <span className="tabular-nums">{usd(avance.alcanzadoCents)} de {usd(avance.metaCents)} ({avance.pct}%)</span>
        </div>
        <div className="relative h-2 rounded bg-neutral-200 dark:bg-neutral-800">
          <div className={`h-2 rounded ${avance.cumple ? 'bg-success' : 'bg-warning'}`} style={{ width: `${pct}%` }} />
          {umbral != null && <div className="absolute top-[-3px] h-[14px] w-px bg-neutral-500" style={{ left: `${Math.min(100, umbral)}%` }} />}
        </div>
        <p className="text-caption text-neutral-500 dark:text-neutral-400">
          {umbral == null
            ? 'Cuenta el software nuevo vendido (sin IVA ni servicios).'
            : avance.cumple
              ? `Ya pasaste el mínimo de ${umbral}%: tus comisiones del mes se pagan en planilla.`
              : `Necesitas al menos ${umbral}% de la meta para cobrar las comisiones de este mes.`}
        </p>
      </CardContent>
    </Card>
  )
}
